import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../global/functions/apiClient";
import { getAuthHeaders } from "../global/functions/authorization";
const apiUrl = process.env.REACT_APP_API_URL;
const initialState = {
  items: [],
  status: "idle",
  error: null,
  success: null,
  loading: false,
};

export const getAllergys = createAsyncThunk(
  "allergy/getAllergys",
  async () => {
    try {
      const response = await axios.get(
        `${apiUrl}/allergy`,
        getAuthHeaders(false)
      );
      return response?.data;
    } catch (err) {
      throw new Error(err.response?.data?.message || err.message);
    }
  }
);
export const addAllergy = createAsyncThunk(
  "allergy/addAllergy",
  async (formData) => {
    try {
      const response = await axios.post(
        `${apiUrl}/allergy`,
        formData,
        getAuthHeaders(true)
      );
      return response?.data;
    } catch (err) {
      throw new Error(err.response?.data?.message || err.message);
    }
  }
);

export const modifyAllergy = createAsyncThunk(
  "allergy/modifyAllergy",
  async ({ body, allergyId }) => {
    try {
      const response = await axios.put(
        `${apiUrl}/allergy/${allergyId}`,
        body,
        getAuthHeaders(true)
      );
      return response?.data;
    } catch (err) {
      throw new Error(err.response?.data?.message || err.message);
    }
  }
);
export const deleteAllergy = createAsyncThunk(
  "allergy/deleteAllergy",
  async (allergyId) => {
    try {
      const response = await axios.delete(
        `${apiUrl}/allergy/${allergyId}`,
        getAuthHeaders(false)
      );
      return response?.data;
    } catch (err) {
      throw new Error(err.response?.data?.message || err.message);
    }
  }
);

const allergySlice = createSlice({
  name: "allergy",
  initialState,
  reducers: {
    updateStatus: (state) => {
      state.status = "idle";
    },
  },
  extraReducers(builder) {
    builder
      .addCase(getAllergys.pending, (state, action) => {
        state.status = "loadingFetchData";
        state.loading = true;
      })
      .addCase(getAllergys.fulfilled, (state, action) => {
        state.status = "fetchData";
        state.loading = false;
        state.items = action.payload;
      })
      .addCase(getAllergys.rejected, (state, action) => {
        state.status = "fetchError";
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(addAllergy.pending, (state, action) => {
        state.status = "loading";
        state.loading = true;
      })
      .addCase(addAllergy.fulfilled, (state, action) => {
        state.status = "addSuccess";
        state.loading = false;
        state.success = action.payload.message;
      })
      .addCase(addAllergy.rejected, (state, action) => {
        state.status = "addError";
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(deleteAllergy.pending, (state, action) => {
        state.status = "loading";
        state.loading = true;
      })
      .addCase(deleteAllergy.fulfilled, (state, action) => {
        state.status = "deleteSuccess";
        state.loading = false;
        state.success = action.payload.message;
      })
      .addCase(deleteAllergy.rejected, (state, action) => {
        state.status = "deleteError";
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(modifyAllergy.pending, (state, action) => {
        state.status = "loading";
        state.loading = true;
      })
      .addCase(modifyAllergy.fulfilled, (state, action) => {
        state.status = "modifySuccess";
        state.loading = false;
        state.success = action.payload.message;
      })
      .addCase(modifyAllergy.rejected, (state, action) => {
        state.status = "modifyError";
        state.loading = false;
        state.error = action.error.message;
      });
  },
});
export const { updateStatus } = allergySlice.actions;
export const selectAllAllergys = (state) => state.allergy.items;
export const getAllergysStatus = (state) => state.allergy.status;
export const getAllergysError = (state) => state.allergy.error;
export const getAllergysSuccess = (state) => state.allergy.success;
export const getAllergysLoading = (state) => state.allergy.loading;
export default allergySlice.reducer;
